import { configureStore } from "@reduxjs/toolkit";
import uiReducer from "./uiSlice";
import authReducer from "./authSlice";
import cartReducer from "./cartSlice";
import wishlistReducer from "./wishlistSlice";
import categoriesSlice from "./categoriesSlice";
import searchReduce from "./SearchSlice";
export const store = configureStore({
  reducer: {
    ui: uiReducer,
    auth: authReducer,
    cart: cartReducer,
    wishlist: wishlistReducer,
    categories:categoriesSlice,
    search: searchReduce,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['updateUser/fulfilled'],
        ignoredPaths: ['auth.updateUser.formData'],
      },
    }),
});